// | ------------------------------------------------------------------------
// | Components - Shop - Product Gallery
// | ------------------------------------------------------------------------

import Splide from "@splidejs/splide"; //? https://splidejs.com/

// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  var gallery = document.querySelector(".main-gallery");

  if (gallery) {
    var ThumbGallery = new Splide(".thumbnail-gallery", {
      type: "loop",
      gap: 10,
      perPage: 16,
      perMove: 1,
      cover: true,
      isNavigation: true,
      pagination: false,
      breakpoints: {
        380: {
          perPage: 4,
        },
        576: {
          perPage: 6,
        },
        768: {
          perPage: 10,
        },
        992: {
          perPage: 12,
        },
      },
    }).mount();

    var MainGallery = new Splide(".main-gallery", {
      type: "fade",
      pagination: false,
      arrows: true,
      cover: true,
    });

    MainGallery.sync(ThumbGallery).mount();

    // Light box
    //var lightbox = GLightbox({
    //	touchNavigation: true,
    //	loop: true,
    //});
  }
});
